'use strict';

import React from 'react';
import createClass from 'create-react-class';

const supportedImageTypes = ['jpg', 'jpeg', 'png', 'gif'];
const supportedVideoTypes = ['mp4', 'm4v', 'webm', 'mov'];

const MediaViewer = createClass({
  getInitialState() {
    return {};
  },
  render() {
    if (!this.props.metadata) {
      return (
        <div className="mediaViewer">
          <div>No media specified.</div>
        </div>
      );
    }
    let linkExtension = '';
    if (this.props.metadata.video) {
      linkExtension = this.props.metadata.video.split('.').pop().toLowerCase();
    } else if (this.props.metadata.image) {
      linkExtension = this.props.metadata.image.split('.').pop().toLowerCase();
    }

    let imageLink = this.props.metadata.cdn01 + this.props.metadata.image;
    let videoLink = this.props.metadata.cdn01 + this.props.metadata.video;

    if (supportedImageTypes.indexOf(linkExtension) > -1) {
      return (
        <div
          className={'mediaViewer ' + this.props.className}
          style={{
            width: this.props.width,
            height: this.props.height,
          }}
        >
          <a target="_blank" href={imageLink}>
            <div
              // src={imageLink}
              style={{
                backgroundImage: `url("${imageLink}")`,
                // backgroundSize: '100%',
                width: this.props.width,
                height: this.props.height,
              }}
            />
          </a>
        </div>
      );
    }

    if (supportedVideoTypes.indexOf(linkExtension) > -1) {
      return (
        <div className={'mediaViewer ' + this.props.className}>
          <a target="_blank" href={videoLink}>
            <video preload="auto" controls>
              <source src={videoLink} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </a>
        </div>
      );
    }

    // user published something weird or old here, try to adapt
    var link = this.props.metadata;
    if (this.props.metadata.image) link = this.props.metadata.image;
    if (this.props.metadata.video) link = this.props.metadata.video;

    return (
      <div className={'mediaViewer ' + this.props.className}>
        <a target="_blank" href={link}>
          <div>No preview available.</div>
        </a>
      </div>
    );
  },
});

export default MediaViewer;
